"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_reconciler_1 = __importDefault(require("react-reconciler"));
var hostConfig = {
    now: Date.now,
    getRootHostContext: function () { return ({}); },
    prepareForCommit: function () { },
    resetAfterCommit: function () { },
    getChildHostContext: function () { return ({}); },
    shouldSetTextContent: function () { return true; },
    createInstance: function () { },
    createTextInstance: function () { },
    appendInitialChild: function () { },
    appendChild: function () { },
    finalizeInitialChildren: function () { },
    supportsMutation: true,
    appendChildToContainer: function () { },
    prepareUpdate: function () { return true; },
    commitUpdate: function () { },
    commitTextUpdate: function () { },
    removeChild: function () { }
};
var reconciler = react_reconciler_1.default(hostConfig);
function render(reactElement) {
    var container = reconciler.createContainer(null, false, false);
    return reconciler.updateContainer(reactElement, container, null, null);
}
exports.render = render;
